"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
require("react-datetime/css/react-datetime.css");
var _constants = require("./constants");
var _constants2 = _interopRequireDefault(require("../constants"));
var _dateUtil = _interopRequireDefault(require("../dateUtil"));
var _inputDateTime = _interopRequireDefault(require("./inputDateTime"));
var _timePicker = _interopRequireDefault(require("./timePicker"));
var _dateTimePicker = _interopRequireDefault(require("./dateTimePicker"));
require("./styles.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var shortTimeAMPM = _constants2.default.DateTimeFormat.shortTimeAMPM;
var DateTimeInlinePicker = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(DateTimeInlinePicker, _PureComponent);
  var _super = _createSuper(DateTimeInlinePicker);
  function DateTimeInlinePicker(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DateTimeInlinePicker);
    _this = _super.call(this, props);
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(DateTimeInlinePicker, [{
    key: "onChange",
    value: function onChange(e) {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        timezone = _this$props.timezone;
      if (typeof e === 'string') {
        // The selectedDate isn't valid
        onChange(e);
      } else {
        // The selectedDate is valid
        var selectedDate = !_lodash.default.isEmpty(timezone) ? _dateUtil.default.getDateInTimezone(e, timezone) : e;
        onChange(selectedDate);
      }
    }
  }, {
    key: "generateClassName",
    value: function generateClassName() {
      var _this$props2 = this.props,
        showToday = _this$props2.showToday,
        input = _this$props2.input;
      var dateTimeFieldClass = [];
      if (!showToday) {
        dateTimeFieldClass.push('hidden-today');
      }
      if (input) {
        dateTimeFieldClass.push('arrow');
      } else {
        // The input is hidden, so we should show the calendar in static mode
        dateTimeFieldClass.push('rdtOpen');
      }
      return dateTimeFieldClass.join(' ');
    }
  }, {
    key: "renderTimePicker",
    value: function renderTimePicker(value) {
      var _this$props3 = this.props,
        dinputClass = _this$props3.dinputClass,
        disabled = _this$props3.disabled,
        readOnly = _this$props3.readOnly,
        placeholderText = _this$props3.placeholderText;
      return /*#__PURE__*/_react.default.createElement(_timePicker.default, {
        value: value,
        onChange: this.onChange,
        renderInput: function renderInput(props) {
          return /*#__PURE__*/_react.default.createElement(_inputDateTime.default, (0, _extends2.default)({}, props, {
            dinputClass: dinputClass,
            readOnly: readOnly,
            placeholderText: placeholderText,
            key: "inputTime"
          }));
        },
        format: shortTimeAMPM,
        disabled: disabled,
        className: "time-picker-wrapper ".concat(this.generateClassName()),
        readOnly: this.props.readOnly
      });
    }
  }, {
    key: "renderDateTimePicker",
    value: function renderDateTimePicker(value) {
      var _this$props4 = this.props,
        dinputClass = _this$props4.dinputClass,
        disabled = _this$props4.disabled,
        name = _this$props4.name,
        readOnly = _this$props4.readOnly,
        minDate = _this$props4.minDate,
        maxDate = _this$props4.maxDate,
        viewMode = _this$props4.viewMode,
        dateFormat = _this$props4.dateFormat,
        dateTimeFormat = _this$props4.dateTimeFormat,
        placeholderText = _this$props4.placeholderText;
      return /*#__PURE__*/_react.default.createElement(_dateTimePicker.default, {
        key: "daettimepicker",
        value: value,
        onChange: this.onChange,
        isShowTime: viewMode === _constants.CALENDAR_VIEW_MODE.DATE_TIME,
        renderInput: function renderInput(props) {
          return /*#__PURE__*/_react.default.createElement(_inputDateTime.default, (0, _extends2.default)({}, props, {
            dinputClass: dinputClass,
            readOnly: readOnly,
            name: name,
            key: "uniqueDate",
            placeholderText: placeholderText
          }));
        },
        disabled: disabled,
        dateFormat: dateFormat,
        dateTimeFormat: dateTimeFormat,
        minDate: minDate,
        maxDate: maxDate,
        className: "date-time-picker-wrapper ".concat(this.generateClassName()),
        disableMonthYearSelection: this.props.disableMonthYearSelection
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        timezone = _this$props5.timezone,
        viewMode = _this$props5.viewMode;
      var value = this.props.value;
      if (!_lodash.default.isEmpty(timezone)) {
        value = _dateUtil.default.getDateInTimezone(value, timezone);
      }
      var component = null;
      switch (viewMode) {
        case _constants.CALENDAR_VIEW_MODE.TIME_ONLY:
          component = this.renderTimePicker(value);
          break;
        default:
          component = this.renderDateTimePicker(value);
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(this.props.className, " date-picker-wrapper")
      }, component);
    }
  }]);
  return DateTimeInlinePicker;
}(_react.PureComponent);
DateTimeInlinePicker.propTypes = {
  className: _propTypes.default.string,
  dateFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  dateTimeFormat: _propTypes.default.string,
  dinputClass: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  datePickerProps: _propTypes.default.shape({
    renderDay: _propTypes.default.func,
    renderMonth: _propTypes.default.func,
    renderYear: _propTypes.default.func
  }),
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_momentTimezone.default), _propTypes.default.string]),
  minDate: _propTypes.default.instanceOf(_momentTimezone.default),
  maxDate: _propTypes.default.instanceOf(_momentTimezone.default),
  viewMode: _propTypes.default.string,
  timezone: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  showToday: _propTypes.default.bool,
  input: _propTypes.default.bool,
  // Defines the format for the time.
  // It accepts any Moment.js time format (not in localized format).
  // If true the time will be displayed using the defaults for the current locale.
  // If false the timepicker is disabled and the component can be used as datepicker.
  timeFormat: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  closeOnSelect: _propTypes.default.bool,
  name: _propTypes.default.string,
  placeholderText: _propTypes.default.string,
  disableMonthYearSelection: _propTypes.default.bool
};
DateTimeInlinePicker.defaultProps = {
  value: null,
  dateFormat: _constants.DATE_TIME_FORMAT.shortDate,
  dateTimeFormat: _constants.DATE_TIME_FORMAT.dateTimeAMPM,
  datePickerProps: null,
  // Formcontrol classname when disabled
  dinputClass: null,
  disabled: false,
  viewMode: _constants.CALENDAR_VIEW_MODE.DATE_ONLY,
  className: '',
  timezone: '',
  showToday: false,
  input: true,
  timeFormat: false,
  // When true, once the day has been selected, the datepicker will be automatically closed.
  closeOnSelect: true,
  readOnly: true,
  name: 'dateTimePicker',
  minDate: null,
  maxDate: null,
  placeholderText: '',
  disableMonthYearSelection: false
};
var _default = DateTimeInlinePicker;
exports.default = _default;